import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
const stage = config[env];
const API_URL = stage.base_url + "/user/";

const fetchSelf = (jwt) => {
  const headers = { Authorization: "bearer " + jwt };
  return axios.get(API_URL + "self", { headers: headers });
};


// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
  fetchSelf,
};
